<template>
  <div>
    <v-row class="mx-1 mt-2">
      <template v-for="(item, index) in hierarchyRecords">
        <v-col v-if="index < 3" class="list-hierarchy-Records" cols="12" md :key="index">
          <div class="bg-azul">
            <div class="title-area">{{ item.title }}</div>
            <div>
              <div class="text-area">{{ item.count }}</div>
            </div>
          </div>
        </v-col>
        <v-col v-else-if="index >= 3 && index < 6" class="list-hierarchy-Records" cols="12" md :key="index">
          <div class="bg-azul">
            <div class="title-area">{{ item.title }}</div>
            <div>
              <div class="text-area">{{ item.count }}</div>
            </div>
          </div>
        </v-col>
      </template>
    </v-row>
    <ProcessDashboard ref="ProcessHierarchy" :boardings="boardings" :isConfirmationStep="isConfirmationStep" />
    <div v-if="errorsJson.length > 0" class="px-4">
      <v-card class="column">
        <div class="d-flex justify-space-between align-center column-title">
          <div class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Erros na importação</h1>
          </div>
        </div>
        <ProcessErrorsTable :errorsJson="errorsJson" />
      </v-card>
    </div>

    <div class="pa-4">
      <v-card class="column">
        <v-progress-linear v-if="isBoardingLoading" indeterminate absolute />
        <div class="d-flex justify-space-between align-center column-title">
          <div class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Detalhes dos embarques</h1>
          </div>
        </div>
        <div class="list-hierarchy">
          <ProcessHierarchy
            ref="ProcessHierarchy"
            v-for="item in boardings"
            :importedSuccessfully="importedSuccessfully"
            :boarding="item"
            :key="item.id"
          />
        </div>
      </v-card>
    </div>

    <div v-if="canShowUnallocated" class="pa-4">
      <v-card class="column">
        <v-progress-linear v-if="isUnallocatedLoading" indeterminate absolute />
        <div class="d-flex justify-space-between align-center column-title">
          <div class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Agrupamentos não alocados</h1>
          </div>
        </div>
        <div class="list-hierarchy">
          <div v-if="unallocatedCargos.length > 0" class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Cargas:</h1>
          </div>
          <UnallocatedCargo ref="UnallocatedCargo" v-for="item in unallocatedCargos" :cargo="item" :key="item.id" />
          <div v-if="unallocatedStops.length > 0" class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Paradas:</h1>
          </div>
          <UnallocatedStops ref="UnallocatedStops" v-for="item in unallocatedStops" :stop="item" :key="item.id" />
          <div v-if="unallocatedDeliveries.length > 0" class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Entregas:</h1>
          </div>
          <UnallocatedDeliveries
            ref="UnallocatedDeliveries"
            v-for="item in unallocatedDeliveries"
            :delivery="item"
            :key="item.id"
          />
          <div v-if="unallocatedNfes.length > 0" class="d-flex align-center">
            <h1 class="title-area text-left black--text font-weight-medium">Nfes:</h1>
          </div>
          <UnallocatedNfes ref="UnallocatedNfes" v-for="item in unallocatedNfes" :nfe="item" :key="item.id" />
        </div>
      </v-card>
    </div>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed"
      @confirmClick="$emit('confirmClick')"
      title="Confirmar Importação"
      @cancelClick="isOpenConfirmationComputed = false"
      body-text="Você confirma a importação dos embarques?"
    />
  </div>
</template>

<script>
import ProcessDashboard from '@/components/ManualBoardingImport/Stepper/Step7/ProcessDashboard.vue';
import ProcessHierarchy from '@/components/ManualBoardingImport/Stepper/Step7/HierarchyDetails/BoardingHierarchyDetails.vue';
import UnallocatedCargo from '@/components/ManualBoardingImport/Stepper/Step7/UnallocatedHierarchy/CargoUnallocatedHierarchy.vue';
import UnallocatedStops from '@/components/ManualBoardingImport/Stepper/Step7/UnallocatedHierarchy/StopUnallocatedHierarchy.vue';
import UnallocatedDeliveries from '@/components/ManualBoardingImport/Stepper/Step7/UnallocatedHierarchy/DeliveryUnallocatedHierarchy.vue';
import UnallocatedNfes from '@/components/ManualBoardingImport/Stepper/Step7/UnallocatedHierarchy/NfesUnallocatedHierarchy.vue';
import ProcessErrorsTable from '@/components/ManualBoardingImport/Stepper/Step7/ProcessErrorsTable.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import { mapActions } from 'vuex';

export default {
  name: 'ConfirmationStep',
  components: {
    ProcessDashboard,
    ProcessHierarchy,
    ProcessErrorsTable,
    UnallocatedCargo,
    UnallocatedStops,
    UnallocatedDeliveries,
    UnallocatedNfes,
    ConfirmDialog
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    process: {
      type: Object,
      default: () => {}
    },
    hierarchyRecords: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isBoardingLoading: false,
    isUnallocatedLoading: false,
    importedSuccessfully: false,
    boardings: [],
    unallocatedCargos: [],
    unallocatedStops: [],
    unallocatedDeliveries: [],
    unallocatedNfes: [],
    errorsJson: [],
    hierarchyRecords: [],
    filteredBoardings: []
  }),
  mounted() {
    this.fetchQuantitiesHierarchy();
    this.fetchUnallocated();
    this.fetchBoarding();
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    hasUnallocatedItems() {
      return (
        this.unallocatedCargos.length > 0 ||
        this.unallocatedStops.length > 0 ||
        this.unallocatedDeliveries.length > 0 ||
        this.unallocatedNfes.length > 0
      );
    },
    isConfirmationStep() {
      return this.process.stepName === 'Confirmação de embarques';
    },
    canShowUnallocated() {
      return this.isConfirmationStep && this.hasUnallocatedItems;
    }
  },
  methods: {
    ...mapActions('ImportManualDashboardStore', ['fetchQuantitiesHierarchyRecords']),
    ...mapActions('ImportManualBoardingsStore', ['getAllBoarding', 'getAllUnallocatedCargos']),
    ...mapActions('ImportManualCargosStore', ['getAllUnallocatedStops']),
    ...mapActions('ImportManualStopsStore', ['getAllUnallocatedDeliveries']),
    ...mapActions('ImportManualDeliveryStore', ['getAllUnallocatedNfes']),

    async fetchQuantitiesHierarchy() {
      try {
        const data = await this.fetchQuantitiesHierarchyRecords(this.parameterID);
        this.hierarchyRecords = [
          { title: 'Total de NFes', count: data.nfesQuantity },
          { title: 'Entregas', count: data.deliveriesQuantity },
          { title: 'Paradas', count: data.stopsQuantity },
          { title: 'Cargas - entrega direta', count: data.directDeliveryCargosQuantity },
          { title: 'Cargas - transferências', count: data.transhipmentCargosQuantity },
          { title: 'Embarques', count: data.boardingsQuantity }
        ];
        this.totalRecords = {
          totalNFes: data.nfesQuantity,
          totalDeliveries: data.deliveriesQuantity,
          totalStops: data.stopsQuantity,
          totalCargos: data.directDeliveryCargosQuantity + data.transhipmentCargosQuantity,
          totalBoardings: data.boardingsQuantity
        };
      } catch (err) {
        console.error(err);
      }
    },
    async fetchBoarding() {
      try {
        this.isBoardingLoading = true;
        this.errorsJson = JSON.parse(this.process.errorsJson) || [];
        if (this.process.dataJson != null) {
          this.importedSuccessfully = true;
          this.boardings = JSON.parse(this.process.dataJson);
        } else {
          const data = await this.getAllBoarding(this.parameterID);
          this.boardings = data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isBoardingLoading = false;
      }
    },
    async fetchUnallocated() {
      this.isUnallocatedLoading = true;
      try {
        const [cargos, stops, deliveries, nfes] = await Promise.all([
          this.getAllUnallocatedCargos(this.parameterID),
          this.getAllUnallocatedStops(this.parameterID),
          this.getAllUnallocatedDeliveries(this.parameterID),
          this.getAllUnallocatedNfes(this.parameterID)
        ]);

        this.unallocatedCargos = cargos;
        this.unallocatedStops = stops;
        this.unallocatedDeliveries = deliveries;
        this.unallocatedNfes = nfes;
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list-hierarchy {
  width: 100%;
  height: auto;
  max-height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
}
::v-deep .list-hierarchy::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

::v-deep .list-hierarchy::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
  min-height: 40px; /* Tamanho mínimo aumentado */
}

::v-deep .list-hierarchy::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.bg-azul {
  background: #1f77b4;
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  height: 80px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
}
.title-area {
  padding-left: 10px;
  padding-top: 8px;
  font-size: 16px;
  height: 36px;
  width: 100%;
  color: #ffffff;
  font-weight: bolder;
}
.text-area {
  padding-left: 10px;
  margin-bottom: 6px;
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
}
::v-deep .v-list-item {
  min-height: 24px;
}

@media only screen and (max-width: 1636px) {
  .list-hierarchy-Records {
    flex: 0 0 33%;
    max-width: 33%;
  }
}
</style>
